<template>
  <div>
    <div class="section-right-content-box">
      <div class="integralChange publicStyle" style="padding: 0">
        <div>
          <!-- <span class="jifRecords">标签管理</span>&nbsp;&nbsp;
            <span style="color:#333333">最多可设置
              <span style="color:#FE4D45">100</span>
              个标签，另外增加
              <span style="color:#4878FF">47</span>
              个标签  
            </span>   -->
        </div>
        <el-alert title :closable="false" class="tips_title">
          <template slot="title">
            <div>
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 5px 4px 0 80px;
                "
              /><span class="jifRecords">标签管理</span>&nbsp;&nbsp;
              <span
                style="padding-right: 16px; color: #666666; margin-left: 24px"
              >
                标签管理：最多可设置
                <span style="color: #5882fb; margin: 0 4px">100</span
                >个标签，还可增加
                <span style="color: #fd695b; margin: 0 4px">{{
                  100 - totalNum
                }}</span
                >个标签
              </span>
            </div>
          </template>
        </el-alert>
        <!-- <top-title :name="'标签管理'" :desc="'最多可设置 100 个标签，另外增加 47 个标签'"></top-title> -->
        <div class="lineTwo"></div>
        <div class="item">
          <div class="item-name" style="margin-right: 8px">标签搜索:</div>
          <el-input
            class="long-input"
            size="small"
            style="width: 220px; margin: 0 20px 0 0"
            placeholder="请输入..."
            v-model="valueLabel"
          ></el-input>
          <!-- <el-button
              icon="el-icon-search-outline"
              type="danger"
              class="status_btn status_btn1"
            >查询</el-button>
          <el-button class="status_btn status_btn2" @click="resetBtn1">重置</el-button>-->

          <el-button
            icon="el-icon-search"
            class="status_btn1"
            style="width: 98px"
            v-zoom="{ from: pageName, name: '查询' }"
            @click="searchContent"
            >查询</el-button
          >
          <el-button class="status_btn2" @click="resetBtn1">重置</el-button>
        </div>
      </div>
      <div class="publicStyle">
        <div style="margin: 20px 0px 20px 0px">
          <el-button
            @click="newLabel"
            v-zoom="{ from: pageName, name: '新建标签' }"
            class="status_btn3"
          >
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />新建标签</el-button
          >
          <el-button
            @click="batchDeletion"
            v-zoom="{ from: pageName, name: '批量删除' }"
            class="status_btn2"
            style="margin-left: 15px; width: 90px"
            >批量删除</el-button
          >
        </div>

        <!-- <el-button
          style="float:right;color:#2062E7;border:1px solid #2062E7;height:32px;margin-bottom:15px;"
          @click="showExportDialog"
        > 
          <span class="font_family icon-daochu" style="margin-right: 8px;vertical-align: middle;"></span>
          <span style="font-size:14px;font-family:PingFangSC-Regular,PingFang SC;">导出数据</span>
        </el-button>
        <a :href="filePath" style="position:absolute;left: 9999em;bottom: 999em;" target="_blank" :download="fileName" ref="filelink"><span ref="downloadFile">download</span></a>-->
        <el-table
          v-loading="tableLoading"
          tooltip-effect="light"
          :data="tableData"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="border: 1px solid #eee"
          empty-text="暂无数据"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column label="标签名称">
            <template slot-scope="scope">
              <span>{{ scope.row.labelName }}</span
              >&nbsp;
              <span
                class="el-icon-edit-outline"
                @click="reviseLabel(scope.row)"
                v-zoom="{ from: pageName, name: '修改标签名称' }"
                style="cursor: pointer"
              ></span>
            </template>
          </el-table-column>

          <el-table-column prop="buyerCount" label="客户数"></el-table-column>
          <el-table-column prop="crtime" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <span
                type="text"
                @click="marketNow(scope.$index, scope.row)"
                v-zoom="{ from: pageName, name: '立即营销' }"
                class="operation"
                >立即营销</span
              >
              <span
                type="text"
                v-if="scope.row.buyerCount <= 0"
                class="operationno"
                >详情</span
              >
              <span
                type="text"
                v-else
                @click="content(scope.$index, scope.row)"
                v-zoom="{ from: pageName, name: '详情' }"
                class="operation"
                >详情</span
              >
              <span
                type="text"
                @click="handleDelete(scope.row.id)"
                v-zoom="{ from: pageName, name: '删除' }"
                class="operation"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 表格分页 -->
        <el-pagination
          background
          style="text-align: right; margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formDataList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          :current-page="formDataList.current"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import topTitle from "@/components/top-title.vue";
import { mapState } from "vuex";
import {
  getBuyerLabelByLabelName,
  deleteLabelById,
  addBuyerLabel,
  updateLabelNameById,
} from "@/api/buyerLabelController";
// import {
//      queryList,
//      exportList
//      } from "@/api/wechat/wechatOpenCard";
export default {
  name: "label_manage",
  filters: {
    statusStr(status) {
      return { 0: "未知", 1: "男", 2: "女", null: "null" }[status];
    },
  },
  components: {
    topTitle,
  },
  data() {
    return {
      pageName: "客户管理-标签管理",
      multipleSelection: [], //选择列表
      valueLabel: "", //搜索
      //表单数据
      formDataList: {
        // nickname: "", //买家名称
        // mobile: "", //手机号码
        size: 10,
        current: 1,
        message: "",
        // labelName: "", //标签名字
        id: "", //标签id
      },
      sellerNick: "",

      tableData: [],
      tableLoading: true,
      totalNum: 0,
      filePath: "",
      fileName: "",
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    //查询事件
    queryList() {
      getBuyerLabelByLabelName(this.formDataList)
        .then((res) => {
          if (res && res.code == 1) {
            this.tableLoading = false;
            this.tableData = res.data.records;
            this.totalNum = res.data.total;
          }
        })
        .catch((res) => {});
    },
    //搜索
    searchContent() {
      this.formDataList.current = 1;
      if (this.valueLabel.length < 15) {
        this.formDataList.labelName = this.valueLabel;
        this.queryList();
      } else {
        this.$message.error("不能超过15字符");
      }
      // console.log(this.formDataList.labelName);
    },
    //删除
    handleDelete(id) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteLabelById(id).then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.queryList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //监听表格多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量删除
    batchDeletion() {
      // console.log(ids);
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          let idsArr = [];
          this.multipleSelection.forEach((item) => {
            idsArr.push(item.id);
          });
          deleteLabelById(idsArr).then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.queryList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //分页事件
    handleSizeChange(val) {
      this.formDataList.current = 1;
      this.formDataList.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.formDataList.current = val;
      this.queryList();
    },
    //新建标签
    newLabel() {
      this.$prompt("请输入标签", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]{1,15}$/,
        inputErrorMessage: "标签格式不正确",
      })
        .then(({ value }) => {
          let dto = {
            labelName: value,
          };
          if (this.totalNum >= 100) {
            this.$message.warning("最多可设置100个标签");
            return;
          }
          addBuyerLabel(dto).then((res) => {
            if (res && res.code == 1) {
              this.$message.success("添加成功");
              this.queryList();
            } else if (res.message == "该标签名称已存在") {
              this.$message.error("标签已存在");
            } else {
              this.$message.error("添加失败");
            }
          });
        })
        .catch(() => {
          this.$message.info("取消输入");
        });
    },
    //修改标签
    reviseLabel(val) {
      this.$prompt("请输入标签", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]{1,15}$/,
        inputErrorMessage: "标签格式不正确",
      })
        .then(({ value }) => {
          this.$message.success("修改成功");
          let dto = {
            labelName: value,
            id: val.id,
          };
          updateLabelNameById(dto).then((res) => {
            if (res && res.code == 1) {
              let labelName = dto.labelName;
              // console.log(labelName);
              this.queryList();
            }
          });
        })
        .catch(() => {
          this.$message.info("取消输入");
        });
    },

    //立即营销
    marketNow(index, row) {
      if (row.buyerCount > 1) {
        let routeUrl = this.$router.resolve({
          path: "/marketing/marketing/member_send",
          query: { incluseLableIds: row.id, labelType: 1 },
        });
        console.log(row.id);
        window.open(routeUrl.href, "_blank");
      } else {
        this.$message.error("京东官方规定人数少于2无法发送，请增加营销人数~");
      }
    },
    //详情
    content(index, row) {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/focusShop",
        // query: { labelList: JSON.stringify(row) },
        query: { labelList: row.id },
      });
      window.open(routeUrl.href, "_blank");
    },
    //重置
    resetBtn1() {
      this.valueLabel = "";
      this.formDataList = {
        size: 10,
        current: 1,
      };
      this.queryList();
    },
    //导出
    showExportDialog() {
      exportList(this.formDataList)
        .then((res) => {
          if (res.code == 200) {
            // let url=res.data;
            // let exportStart=url.lastIndexOf(".");
            // let type=url.substring(exportStart);
            // let elem=document.createElement("a");
            // elem.style.display="none";
            // elem.href=this.$BaseUrl+"/"+url;
            // elem.target="blank";
            // elem.setAttribute("download",url);
            // document.body.appendChild(elem);
            // elem.click();
            this.$message.success(res.message);
            this.$data.filePath = `/api/${res.data}`;
            // http://120.79.18.7:18888/api/file_xls/中差评管理20190731091800.xlsx
            let nameArr = res.data.split("/");
            this.$data.fileName = nameArr[nameArr.length - 1];
            let outIsProgress = setTimeout(() => {
              this.$refs.downloadFile.click();
              clearTimeout(outIsProgress);
            }, 300);
          } else {
            this.$message.success("无可导出数据！");
          }
        })
        .catch((res) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
// /deep/.el-table__empty-text {
//     display: inline-block;
//     padding-top: 100px;
//     cursor: pointer;
//     background:url('../../assets/images/nodata.png') center no-repeat
//     color: #909399;
//     box-sizing: border-box;
// }
.section-right-content-box {
  min-width: 1080px;
  padding: 0px 0px;
  .publicStyle {
    background-color: #fff;
    box-sizing: border-box;
    padding: 4px 16px 16px 30px;
    margin: 20px 20px 20px 20px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    .el-icon-edit-outline {
      &:hover {
        color: #fe4d45;
      }
    }
  }
  .operationno {
    color: #ddd;
    margin-right: 20px;
  }
  .operation {
    cursor: pointer;
    color: #7f85e9;
    margin-right: 20px;
    &:hover {
      color: #fe4d45;
    }
  }
  .status_btn {
    width: 98px;
    // height: 32px;
    background-color: #fff;
    font-size: 14px;
  }
  .status_btn1 {
    color: #fe4d45;
    font-size: 14px;
    border: 1px solid #fe4d45;
  }
  .integralChange {
    margin-top: 10px;
    .tips_title {
      margin: 0 0 -10px 10px;
      width: 500px;
      background-color: #fff;
      padding-top: 20px;
    }
    .jifRecords {
      width: 80px;
      height: 22px;
      font-size: 16px;
      // font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      color: rgba(46, 52, 88, 1);
      opacity: 1;
    }
    .item {
      margin: 8px 0 25px 30px;
      display: inline-block;
      vertical-align: middle;
      color: #333;
      font-size: 14px;
      margin-right: 42px;
      .item-name {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        display: inline-block;
      }
      .long-input {
        display: inline-block;
        width: 280px;
        margin-right: 35px;
      }
    }
  }
  .bottombase {
    margin-top: -35px;
  }
  .lineTwo {
    //  height:1px;
    background: rgba(246, 246, 246, 1);
    opacity: 1;
    padding: 0px !important;
    //  margin-top: 16px;
    margin-bottom: 20px;
  }
  .status_btn1 {
    width: 98px;
    font-size: 14px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
  }
  .status_btn1:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
  .status_btn2 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
  }
  .status_btn2:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
  .status_btn3 {
    width: 98px;
    height: 32px;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    font-size: 14px;
    color: #ffffff;
    background-color: #fe4d45;
  }
  .status_btn3:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }
}
</style>
